document.addEventListener('DOMContentLoaded', function () {
  let allVariants = [];

  fetch('/products/serum-a-rouleau-capillaire-micro-infusion.js')
    .then(r => r.json())
    .then(p => { allVariants = p.variants; });

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0EUR';
  }

  function updatePriceDisplay(variantId) {
    const variant = allVariants.find(v => v.id == variantId);
    if (!variant) return;

    document.querySelectorAll('.price-item--sale').forEach(el => {
      el.textContent = formatPrice(variant.price);
    });

    document.querySelectorAll('.price-item--regular').forEach(el => {
      el.textContent = variant.compare_at_price ? formatPrice(variant.compare_at_price) : '';
    });

    document.querySelectorAll('input[name="id"]').forEach(el => {
      el.value = variantId;
    });

    const eliteInput = document.querySelector('.product-variant-id');
    if (eliteInput) {
      eliteInput.value = variantId;
      eliteInput.setAttribute('data-selected-id', variantId);
      eliteInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function attachListeners() {
    document.querySelectorAll('.kaching-bundles__bar-main').forEach(function (bar) {
      if (bar.dataset.syncAttached) return;
      bar.dataset.syncAttached = 'true';
      bar.addEventListener('click', function () {
        const titleEl = bar.querySelector('.kaching-bundles__bar-title');
        if (!titleEl) return;
        const title = titleEl.textContent.trim();
        let variantId = null;
        if (title.includes('DÉCOUVERTE') || title.includes('Découverte')) variantId = 56819225493882;
        else if (title.includes('RECOMMANDÉE') || title.includes('Recommandée')) variantId = 56819225526650;
        else if (title.includes('PRO') || title.includes('Pro')) variantId = 56819225559418;
        if (variantId) updatePriceDisplay(variantId);
      });
    });
  }

  const observer = new MutationObserver(attachListeners);
  observer.observe(document.body, { childList: true, subtree: true });
  attachListeners();
});